import {
  ObbPotentialBetsValidations,
  ObbValidationSeverities,
  ObbValidationTypes,
} from "@ppb/tbd-store/state/betting/obb-betting/ObbBetting.types";
import type { BetslipLocalization, CountryCode, Jurisdiction } from "../contract";

type ValidationTerritory = {
  countries: CountryCode[];
  jurisdictions: Jurisdiction[];
};

type ValidationsMap = {
  [k in ObbValidationTypes]?: {
    ImplyBets: ValidationTerritory;
    Config: ValidationTerritory;
  };
};

const VALIDATIONS: ValidationsMap = {
  [ObbValidationTypes.ABOVE_MAX_PAYOUT]: {
    ImplyBets: {
      countries: [],
      jurisdictions: ["ITALY"],
    },
    Config: {
      countries: ["GB", "IE"],
      jurisdictions: ["BRAZIL"],
    },
  },
};

export const isTerritoryApplicableValidation = (
  validationType: ObbValidationTypes,
  { jurisdiction, countryCode }: BetslipLocalization,
): boolean => {
  switch (validationType) {
    case ObbValidationTypes.ABOVE_MAX_PAYOUT:
      return !!(
        VALIDATIONS[validationType]?.ImplyBets.countries.includes(countryCode) ||
        (!!jurisdiction && VALIDATIONS[validationType]?.ImplyBets.jurisdictions.includes(jurisdiction))
      );
    default:
      return true;
  }
};

export const hasSpecialValidation = (
  validationType: ObbValidationTypes,
  { jurisdiction, countryCode }: BetslipLocalization,
  hasAboveMaxStakeValidation: boolean,
): boolean => {
  switch (validationType) {
    case ObbValidationTypes.ABOVE_MAX_PAYOUT:
      return (
        !hasAboveMaxStakeValidation &&
        !!(
          VALIDATIONS[validationType]?.Config.countries.includes(countryCode) ||
          (!!jurisdiction && VALIDATIONS[validationType]?.Config.jurisdictions.includes(jurisdiction))
        )
      );
    default:
      return false;
  }
};

export const isStakeValid = (
  localization: BetslipLocalization,
  validations?: ObbPotentialBetsValidations[],
): boolean => {
  if (!validations) {
    return true;
  }

  return !validations
    .filter((validation) => isTerritoryApplicableValidation(validation.type, localization))
    .filter((validation) =>
      "severity" in validation ? validation.severity === ObbValidationSeverities.ERROR : !!validation,
    ).length;
};
